
export const MyLoading = props => {
  return (
    <div className="loading"><div></div></div>
  );
};

export default MyLoading;
